export enum paginateEnums {
    EVENT_PAGINATE = 'eventPaginate',
    USER_EVENT_PAGINATE = 'userEventPginate',
    HISTORY_LOYALTY_PAGINATE = 'history_loyalty_paginate',
    ENTERTAINMENT_RECORDS_PAGINATE = 'entertainment_records_paginate'
}